SearchEventEmitter = function () {};
heir.inherit(SearchEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
SearchEventEmitter.prototype.addListener = function (name, action, listener) {
    AppEventEmitter.prototype.addListener.call(this, (name + '.' + action), listener);
};
// noinspection JSCheckFunctionSignatures
SearchEventEmitter.prototype.emitEvent = function (name, action, args) {
    args = args || {};
    $.extend(args, { e: $('#search_' + name.replace('.', '_')), name: name });
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    AppEventEmitter.prototype.emitEvent.call(this, (name + '.' + action), [ args ]);
};

app.search = new SearchEventEmitter();
app.search.SUBMIT = 'submit';

// app.search.on('*', app.search.SUBMIT, function (search) {
//     if ($('#grid_' + search.name.replace('.', '_')).length) {
//         app.grid.trigger(search.name, app.grid.UPDATE, {
//             page: 1
//         });
//     }
// });
